.topBar {
  height: 38px !important;
  & :focus:not(:focus-visible) {
    outline: 0 !important;
  }
}